import { createFeatureSelector, createSelector } from '@ngrx/store'
import { IFinanceExpensesState, IFinanceOverviewState } from '@adex/shared/models/states/finance.state'
import { buildArrayMapFromArray } from '@adex/shared/utils/array-map'


export const financeOverviewState = createFeatureSelector<IFinanceOverviewState>('financeOverviewState')
export const financeExpensesState = createFeatureSelector<IFinanceExpensesState>('financeExpensesState')
export const selectFinanceExpensesTablePagination = createSelector(financeExpensesState, state => state.pagination)
export const selectFinanceExpensesData = createSelector(financeExpensesState, state => state.data)
export const selectFinanceRealTimeAnalysis = createSelector(financeOverviewState, state => state?.realTimeAnalysis)
export const selectFinanceCurrentTariffId = createSelector(selectFinanceRealTimeAnalysis, state => state?.currentTariffId)
export const selectFinanceTariff = createSelector(selectFinanceRealTimeAnalysis, state => state?.tariffs)
export const selectFinanceCurrentTariff = createSelector(selectFinanceCurrentTariffId, selectFinanceTariff,
  (id, tariffs) => tariffs?.find(t => t.id === id))

export const selectFinanceTariffMap = createSelector(selectFinanceTariff, state => buildArrayMapFromArray(state || [], 'id'))
